import React from 'react';
import { ArrowRightIcon, CheckIcon, BookOpenIcon, MicIcon, CalendarIcon, LayersIcon } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function LeadingInComplexity() {
  const {
    t
  } = useLanguage();
  const signs = t('leadingInComplexity.signs') as string[];
  const whatWeDoItems = t('leadingInComplexity.whatWeDoItems') as string[];
  return <PageTransition data-id="element-1473" data-mp="y0fu56zq4gna">
      <div className="pt-12 pb-24" data-id="element-1474" data-mp="xz4v1kh83x2i">
        {/* Hero */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1475" data-mp="1uk5f95ggobre">
          <DecorativeShape type="blob" color="bg-blue-100/60" className="top-0 right-0 w-[500px] h-[500px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-1476" data-mp="1prvh525705e1" />
          <Animate className="max-w-3xl" data-id="element-1477" data-mp="cttv0ft1qqbm">
            <span className="inline-block px-4 py-2 bg-blue-50 text-blue-700 font-medium rounded-full text-sm mb-6" data-id="element-1478" data-mp="csr6ufn3z1ze">
              {t('leadingInComplexity.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-1479" data-mp="3269swn325il">
              {t('leadingInComplexity.title')}
              <br data-id="element-1480" data-mp="3l7srrjnuefq6" />
              <span className="text-blue-600" data-id="element-1481" data-mp="3q86z0zhmdln5">{t('leadingInComplexity.titleHighlight')}</span>
            </h1>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-1482" data-mp="3bb64ypbyheli">
              {t('leadingInComplexity.intro1')}
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1483" data-mp="3gb28yoknl612">
              {t('leadingInComplexity.intro2')}
            </p>
            <Link to="/contact" data-id="element-1484" data-mp="19hgmdzb9jii7">
              <Button size="lg" rightIcon={<ArrowRightIcon size={20} data-id="element-1486" data-mp="1ehl5lx3k2rc4" />} data-id="element-1485" data-mp="1eie6ihfu2mmc">
                {t('leadingInComplexity.heroCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        {/* Signs */}
        <section className="bg-cream py-20 mb-20" data-id="element-1487" data-mp="181cjks49geiu">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1488" data-mp="184qni4skovse">
            <Animate className="mb-12" data-id="element-1489" data-mp="133t5ptbh63rf">
              <h2 className="text-3xl font-bold text-charcoal" data-id="element-1490" data-mp="z1plaf6tvou0">
                {t('leadingInComplexity.signsTitle')}
              </h2>
            </Animate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1491" data-mp="1vrgqb8cqwue2">
              {signs.map((sign, i) => <Animate key={i} delay={i * 0.05} data-id="element-1492" data-mp="1qtng848bng8i" data-mpi={i}>
                  <div className="flex items-start gap-3 bg-white rounded-2xl p-5 shadow-sm" data-id="element-1493" data-mp="1m1dmed435w0y">
                    <div className="mt-0.5 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1494" data-mp="1i13dosowsrie">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1495" data-mp="2eipz1feozf4l" />
                    </div>
                    <span className="text-gray-700" data-id="element-1496" data-mp="29rzqxuevsy67">{sign}</span>
                  </div>
                </Animate>)}
            </div>
          </div>
        </section>

        {/* What we work on */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1497" data-mp="17ert217gf4w">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-1498" data-mp="59rxxrjv6f27">
            <Animate data-id="element-1499" data-mp="5bw7oq4g28ae">
              <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-1500" data-mp="a8mqhl7mvhzi">
                {t('leadingInComplexity.whatWeDoTitle')}
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-1501" data-mp="f76a3eyr8hop">
                {t('leadingInComplexity.whatWeDoP1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1502" data-mp="oxr74xys5e5i">
                {t('leadingInComplexity.whatWeDoP2')}
              </p>
            </Animate>
            <Animate delay={0.1} data-id="element-1503" data-mp="syuqhug1dsbh">
              <div className="space-y-3" data-id="element-1504" data-mp="xyh25zg7v0i6">
                {whatWeDoItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1505" data-mp="xwmi0ncrrcf5" data-mpi={i}>
                    <div className="mt-1 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1506" data-mp="12y1y0103asqo">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1507" data-mp="p98m022v3w2h" />
                    </div>
                    <span className="text-gray-700" data-id="element-1508" data-mp="kayuc1gcjdlm">{item}</span>
                  </div>)}
              </div>
            </Animate>
          </div>
        </section>

        {/* Ways to work together */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1509" data-mp="u2bk8nil3tp0">
          <Animate className="mb-12" data-id="element-1510" data-mp="6cqot558v3yu">
            <h2 className="text-3xl font-bold text-charcoal" data-id="element-1511" data-mp="6dsd4bb9tmyi">
              {t('leadingInComplexity.waysTitle')}
            </h2>
            <p className="text-gray-500 mt-2" data-id="element-1512" data-mp="gaobho7ggspc">{t('leadingInComplexity.waysSubtitle')}</p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1513" data-mp="basjknc18rq5">
            {[{
            icon: <BookOpenIcon size={24} className="text-blue-600" data-id="element-1514" data-mp="1roimhqrf19y7" />,
            typeBg: 'bg-blue-50 text-blue-700',
            typeKey: 'courseLabel',
            titleKey: 'course1Title',
            descKey: 'course1Desc',
            path: '/services/courses'
          }, {
            icon: <LayersIcon size={24} className="text-teal" data-id="element-1515" data-mp="1zae3tkqq5q60" />,
            typeBg: 'bg-teal/10 text-teal',
            typeKey: 'workshopLabel',
            titleKey: 'workshop1Title',
            descKey: 'workshop1Desc',
            path: '/services/workshops'
          }, {
            icon: <MicIcon size={24} className="text-yellow-600" data-id="element-1516" data-mp="2d2arncld1dwl" />,
            typeBg: 'bg-yellow-100 text-yellow-700',
            typeKey: 'talkLabel',
            titleKey: 'talk1Title',
            descKey: 'talk1Desc',
            path: '/services/talks'
          }].map((item, i) => <Animate key={i} delay={i * 0.1} data-id="element-1517" data-mp="2vzby71ukbm2n" data-mpi={i}>
                <Card hoverEffect className="h-full p-6 flex flex-col" data-id="element-1518" data-mp="2vxiplh0e2rs0">
                  <div className="flex items-center gap-3 mb-4" data-id="element-1519" data-mp="30qu1vxnz00rb">
                    {item.icon}
                    <span className={`text-xs font-bold px-3 py-1 rounded-full ${item.typeBg}`} data-id="element-1520" data-mp="3akr8z53uq3f2">
                      {t(`leadingInComplexity.${item.typeKey}`)}
                    </span>
                  </div>
                  <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-1521" data-mp="31jt1gcu7fdrq">
                    {t(`leadingInComplexity.${item.titleKey}`)}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-4" data-id="element-1522" data-mp="2rmofoe49tkbg">
                    {t(`leadingInComplexity.${item.descKey}`)}
                  </p>
                  <Link to={item.path} data-id="element-1523" data-mp="2mu3olkcr1lbm">
                    <Button variant="outline" size="sm" rightIcon={<ArrowRightIcon size={16} data-id="element-1525" data-mp="2iuuv8glmfpgl" />} data-id="element-1524" data-mp="2iu3ak0tkbc53">
                      {t('leadingInComplexity.learnMore')}
                    </Button>
                  </Link>
                </Card>
              </Animate>)}
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-1526" data-mp="23ydmzy8qaqy9">
          <Animate data-id="element-1527" data-mp="1ttnndz0sryx7">
            <Card className="p-12 bg-gradient-to-br from-blue-50 to-indigo-50 border-0" data-id="element-1528" data-mp="1tu6zgz3rnt3b">
              <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-1529" data-mp="1yryw26fcw3du">
                <CalendarIcon size={32} className="text-blue-600" data-id="element-1530" data-mp="23swfsng0l5hg" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-1531" data-mp="28qxvqzi58oop">{t('leadingInComplexity.ctaTitle')}</h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-1532" data-mp="1b3p7wxuo73jj">{t('leadingInComplexity.ctaDesc')}</p>
              <Link to="/contact" data-id="element-1533" data-mp="1g17ewip4n8ow">
                <Button variant="primary" rightIcon={<ArrowRightIcon size={18} data-id="element-1535" data-mp="1l1df4n9gq3il" />} data-id="element-1534" data-mp="1g2a6ksu9xf5v">
                  {t('leadingInComplexity.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}